import { BaseActionObject, StateNodeConfig, assign } from "xstate4"
import { Context, Transitions } from "../../../types"
import { getServiceErrorMessage } from "../../../helpers"

export const convertToManual: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  onExit: assign<Context>({ confirmConvertingPlanModal: false }),
  invoke: {
    src: "changeToManualPlan",
    onDone: {
      target: "#StudyPlan.edit_plan.idle",
      actions: assign((_ctx, evt) => ({
        studyPlan: evt.data.plan,
        hasUnsavedStudyPlanChanges: true
      }))
    },
    onError: {
      target: "idle",
      actions: assign({
        snackbar: (_ctx, _evt) => ({
          message: getServiceErrorMessage("changeToManualPlan", {
            messageData: ["convert your plan to manual"]
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
